import styled from 'styled-components';
import { BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const NoSurveysCont = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoOfElementsInfo = styled.span<{ active?: boolean }>`
  font-weight: 800;
  font-size: 40px;
  line-height: 47px;
  ${({ theme }: IThemeProvider) => `
       margin: 0 0 ${theme.layout.spacing.mikro} 0;
     `}
`;

export const NoOfElementsDesc = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
